jQuery(function ($) {
    
    
    //------------------------------
    //スムーススクロール
    //------------------------------

    $('a[href^="#"]').click(function(){
        var adjust = 0; // オフセット値(px)
        var speed = 400;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top + adjust;
        $('body,html').animate({scrollTop:position}, speed, 'linear');
        return false;
    });
    
    
    //------------------------------
    //slide
    //------------------------------

    $("._js-slide").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 800,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        centerMode: true,
        centerPadding:'0',
        variableWidth: true, // 横幅がバラバラなスライドにするか
        dots: false,
        touchThreshold: 100,
    });

    // SP時のみ可動
    function checkBreakpointAndToggleSlick() {
        const windowWidth = $(window).width();
        const targetSelector = "._js-slide-sp";
        if (windowWidth <= 768) {
            // SPサイズ以下のとき
            $(targetSelector).each(function () {
                const $slide_sponly = $(this);

                if (!$slide_sponly.hasClass('slick-initialized')) {
                    // 初期化されていない場合のみ slick を実行
                    $slide_sponly.slick({
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        autoplay: false,
                        autoplaySpeed: 3000,
                        speed: 800,
                        prevArrow: '<div class="slick-prev"></div>',
                        nextArrow: '<div class="slick-next"></div>',
                        centerMode: true,
                        centerPadding:'0',
                        variableWidth: true, // 横幅がバラバラなスライドにするか
                        dots: false,
                        touchThreshold: 100,
                    });
                }
            });
        } else {
            // PCサイズ以上のとき
            $(targetSelector).each(function () {
                const $slide_sponly = $(this);
                // 初期化されている場合のみ unslick を実行
                if ($slide_sponly.hasClass('slick-initialized')) {
                    $slide_sponly.slick('unslick');
                }
            });
        }
    }

    // 初期読み込み時
    checkBreakpointAndToggleSlick();

    // 画面サイズが変更されたとき
    $(window).on('resize', function () {
        checkBreakpointAndToggleSlick();
    });
    
    
    //------------------------------
    //高さをそろえる
    //------------------------------
    
    jsMh();
    
    $(window).resize(function() {
        jsMh();
    });
    
    function jsMh() {
        $('.adt-new-life-2024-product--item--text--ttl').matchHeight({
            byRow: true,
        });
    }
    
    
});
